import { useState } from "react";

const MINUTES_PER_INQUIRY = 5;

export const Calculator = () => {
    const [count, setCount] = useState(15);
    const minutesDay = count * MINUTES_PER_INQUIRY;
    const hoursWeek = (minutesDay * 5) / 60;
    const hoursMonth = hoursWeek * 4.33;

    return (
        <div
            id="kalkulator"
            data-testid="time-calculator"
            className="rounded-2xl border border-white/[0.08] bg-[#161F30]/80 backdrop-blur-xl p-6 sm:p-8 shadow-[0_0_60px_rgba(16,185,129,0.08)] scroll-mt-24"
        >
            <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">
                Beispielrechnung
            </p>
            <h2 className="mt-3 text-xl sm:text-2xl font-medium text-white">
                Wie viel Zeit steckt in Ihrer Routine?
            </h2>
            <div className="mt-8">
                <label htmlFor="inquiries-slider" className="flex items-baseline justify-between text-sm text-[#9CA3AF]">
                    Wiederkehrende Anfragen & Aufgaben pro Tag
                    <span data-testid="calculator-count" className="font-heading text-2xl font-semibold text-emerald-400">
                        {count}
                    </span>
                </label>
                <input
                    id="inquiries-slider"
                    data-testid="calculator-slider"
                    type="range"
                    min="5"
                    max="50"
                    step="1"
                    value={count}
                    onChange={(e) => setCount(Number(e.target.value))}
                    className="kirenzo-slider mt-4 w-full"
                    style={{ "--fill": `${((count - 5) / 45) * 100}%` }}
                    aria-valuetext={`${count} Anfragen pro Tag`}
                />
                <div className="mt-2 flex justify-between text-xs text-[#6B7280]">
                    <span>5</span>
                    <span>50</span>
                </div>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4">
                <div className="rounded-xl border border-white/[0.08] bg-[#0B0F17]/60 p-4">
                    <p data-testid="calculator-hours-week" className="font-heading text-2xl sm:text-3xl font-semibold text-white">
                        {hoursWeek.toFixed(1).replace(".", ",")} h
                    </p>
                    <p className="mt-1 text-xs text-[#9CA3AF]">pro Woche im Postfach gebunden</p>
                </div>
                <div className="rounded-xl border border-white/[0.08] bg-[#0B0F17]/60 p-4">
                    <p data-testid="calculator-hours-month" className="font-heading text-2xl sm:text-3xl font-semibold text-white">
                        {Math.round(hoursMonth)} h
                    </p>
                    <p className="mt-1 text-xs text-[#9CA3AF]">pro Monat – ein halber Arbeitsplatz</p>
                </div>
            </div>
            <p className="mt-6 text-xs text-[#6B7280] leading-relaxed">
                Annahme: Ø 5 Minuten pro Routineaufgabe inkl. Lesen, Zuordnen und Erledigen. Kirenzo übernimmt
                Standardfälle vollständig und sortiert den Rest vor – Ihr Team sieht nur noch, was wirklich
                einen Menschen braucht.
            </p>
        </div>
    );
};
